import { AnyAction, combineReducers } from 'redux';

import { SUPPLIER_SPECIAL_OFFERS_DETAIL_RESET } from './supplier-special-offers-detail-actions';
import {
    SupplierSpecialOffersDetailOverviewReducerState,
    supplierSpecialOffersDetailOverviewReducer,
} from '../overview/store/supplier-special-offers-detail-overview-reducer';
import {
    SupplierSpecialOffersDetailProductsReducerState,
    supplierSpecialOffersDetailProductsReducer,
} from '../products/store/supplier-special-offers-detail-products-reducer';

export interface SupplierSpecialOffersDetailReducerState {
    overview: SupplierSpecialOffersDetailOverviewReducerState;
    products: SupplierSpecialOffersDetailProductsReducerState;
}

const combinedSupplierSpecialOffersDetailReducer = combineReducers<SupplierSpecialOffersDetailReducerState>({
    overview: supplierSpecialOffersDetailOverviewReducer,
    products: supplierSpecialOffersDetailProductsReducer,
});

const initialSupplierSpecialOffersDetailReducerState: SupplierSpecialOffersDetailReducerState =
    combinedSupplierSpecialOffersDetailReducer(undefined, {
        type: '',
    });

export const supplierSpecialOffersDetailReducer = (
    state: SupplierSpecialOffersDetailReducerState = initialSupplierSpecialOffersDetailReducerState,
    action: AnyAction
): SupplierSpecialOffersDetailReducerState => {
    switch (action.type) {
        case SUPPLIER_SPECIAL_OFFERS_DETAIL_RESET:
            return initialSupplierSpecialOffersDetailReducerState;
        default:
            return combinedSupplierSpecialOffersDetailReducer(state, action);
    }
};
